import React, { Component } from 'react'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { API } from 'aws-amplify'
import { CSSTransition } from 'react-css-transition'
import { createBooking } from '../actions/bookingActions'
import Modal from '../components/Modal'
import BookingRentalForm from './BookingRentalForm'
import BookingInsuranceForm from './BookingInsuranceForm'
import BookingInstructionForm from './BookingInstructionForm'
import TransitionStyles from '../lib/transitionStyles'
import Utils, { objEmpty, getSkuPrice } from '../lib/utils'
import PersonRow from '../components/bookingPersonDetailsBlock/PersonRow'
import PersonExpandedBlock from '../components/bookingPersonDetailsBlock/PersonExpandedBlock'
import { calculateHoursCount } from '../lib/booking';

class BookingPersonDetailsBlock extends Component {

  constructor(props) {
    super(props)
    this.state = {
      booking: props.booking,
      personIndex: props.personIndex
    }

    this.onChange             = this.onChange.bind(this)
    this.onChangeByName       = this.onChangeByName.bind(this)
    this.toggle               = this.toggle.bind(this)
    this.openRentalModal      = this.openRentalModal.bind(this)
    this.openInsuranceCancellationModal   = this.openInsuranceCancellationModal.bind(this)
    this.openInstructionModal = this.openInstructionModal.bind(this)
    this.openReplacementCardModal = this.openReplacementCardModal.bind(this)
    this.closeModal           = this.closeModal.bind(this)
    this.clearBookingAttr     = this.clearBookingAttr.bind(this)
    this.addInvite            = this.addInvite.bind(this)
    this.showInvitation       = this.showInvitation.bind(this)
  }

  componentWillReceiveProps(newProps) {
    this.setState({personErrors: newProps.personErrors});
  }

  onChange(e) {
    const {props, state} = this
    const {booking, personIndex} = state
    const { people } = booking 

    if (e.target.name === 'voucher' && e.target.value.length > 6) {
      this.checkVoucher(e.target.value, personIndex)
      this.checkCoupon(e.target.value, personIndex)
    }

    people[personIndex] = {
      ...people[personIndex],
      [e.target.name]: e.target.value
    }
    booking.people = people
    // this.setState({ booking })

    // populate input errors on change
    props.clearErrorByNameAndIndex(personIndex, e.target.name, e.target.value)

    props.createBooking(booking) // TODO Don't do this every change - can throw qouta exeeded + slow
  }

  onChangeByName(name, value) {
    const { props, state } = this
    const { booking, personIndex } = state

    // clear validation errors if any
    props.clearErrorByNameAndIndex(personIndex, 'ageCategory')

    if (name === 'passType') {
      this.checkVoucher(booking.people[personIndex].voucher, personIndex)
      props.clearErrorByNameAndIndex(personIndex, 'passType')
      
    }

    booking.people[personIndex][name] = booking.people[personIndex][name] === value
      ? null 
      : value

    props.createBooking(booking)
  }

  async checkVoucher(code, personIndex) {
    const { props } = this
    const { skus } = props
    const { booking } = this.state
    let voucher = null
    const codeFormatted = code && code.trim()

    this.setState({ checkingVoucher: true })
    booking.people[personIndex].appliedVoucher = null

    const otherPeoplesVouchers = booking.people
      .filter((person, i) => i !== personIndex)
      .map(person => person && person.voucher && person.voucher.trim())
    
    try {
      voucher = await API.get('cphill', `/vouchers/${codeFormatted}`)
      if (!voucher.status && (!otherPeoplesVouchers.includes(codeFormatted) || voucher.maximumRedemptions)) {
        booking.people[personIndex].appliedVoucher = voucher
        
        // Custom legacy functionality specifically for a Ski club partner (Name: Hareskov)
        if (voucher && !voucher.amount) {
          // eslint-disable-next-line import/no-named-as-default-member
          const isHourly = Utils.isHourly(booking.people[personIndex].passType)
          const amount = !booking.people[personIndex].passType || isHourly
            ? 0 
            : (getSkuPrice(booking.people[personIndex].passType, 'skuId', skus) * 0.2) * 100 // Hareskov gets 20%
          booking.people[personIndex].appliedVoucher.amount = amount + 6000 // Hareskov also gets 60 kr. cash off
        }
      }

    } catch (error) {
      // Do nothing
    }
      
    props.createBooking(booking)
    this.setState(prevState => ({ ...prevState, checkingVoucher: false }))
  }

  async checkCoupon(code, personIndex) {
    const { props } = this
    const { booking } = this.state
    const codeFormatted = code && code.trim()

    try {
      const couponInfo = await API.post('cphill', '/stripe/proxy', {
        body: {
          endpoint: 'coupons.retrieve',
          parameters: {
            id: codeFormatted
          }
        }
      })
      booking.people[personIndex].couponInfo = couponInfo
    } catch(e) {
      booking.people[personIndex].couponInfo = null
    }

    props.createBooking(booking)
    this.setState(prevState => ({ ...prevState, checkingVoucher: false }))
  }  
  
  toggle() {

    const { props, state } = this
    const { booking, personIndex } = state
    if (!booking.people) {
      booking.people = []
      booking.people[personIndex] = { expanded : true }
    } else if (!booking.people[personIndex]) {
      booking.people[personIndex] = { expanded: true }
    } else {
      booking.people[personIndex].expanded = !booking.people[personIndex].expanded
    }
    props.createBooking(booking)
  }

  closeModal() {
    this.setState({ currentModal: null })
  }

  openRentalModal() {
    const {props, state} = this
    const {skus} = props
    const {personIndex, booking} = state
    const { people } = booking
    const person = people[personIndex]
    const rentalEquipment = person.rental && person.rental.equipment || {}
    const rentalInfo = person.rental && person.rental.info || {}
    const rentalInsurance = person.rental && person.rental.insurance || false
    const hoursCount = calculateHoursCount(booking.whenStartTime, booking.whenEndTime)
    const ageCategory = person.ageCategory || (person.membership && person.membership.ageCategory)

    const addRentalToPerson = (equipment, info, insurance) => {
      people[personIndex].rental = { equipment, info, insurance}
      booking.people = people
      props.createBooking(booking)
      this.closeModal()
    }

    this.setState({
      currentModal: (
        <Modal closeAction={this.closeModal}>
          <BookingRentalForm
            hoursCount={hoursCount}
            ageCategory={ageCategory}
            equipment={rentalEquipment}
            info={rentalInfo}
            addRentalToPerson={addRentalToPerson}
            insurance={rentalInsurance}
            skus={skus}
          />
        </Modal>
      )
    })
  }

  openInstructionModal() {
    const {props, state} = this
    const {personIndex, booking} = state
    const { people } = booking
    const instructionInfo = people[personIndex].instruction || {}

    const addInstruction = (info) => {
      people[personIndex].instruction = info
      booking.people = people
      props.createBooking(booking)
      this.closeModal()
    }

    this.setState({
      currentModal: (
        <Modal closeAction={this.closeModal}>
          <BookingInstructionForm info={instructionInfo} addInstruction={addInstruction} skus={props.skus} />
        </Modal>
      )
    })
  }

  openInsuranceCancellationModal() {
    const {props, state} = this
    const {personIndex, booking} = state
    const { people } = booking
    const insuranceCancellation = people[personIndex].insuranceCancellation || false

    const addInsuranceToPerson = (info) => {
      people[personIndex].insuranceCancellation = info
      booking.people = people
      props.createBooking(booking)
      this.closeModal()
    }

    this.setState({
      currentModal: (
        <Modal closeAction={this.closeModal}>
          <BookingInsuranceForm insuranceCancellation={insuranceCancellation} addInsuranceToPerson={addInsuranceToPerson} />
        </Modal>
      )
    })
  }

  openReplacementCardModal() {
    this.setState({
      currentModal: (
        <Modal closeAction={this.closeModal}>
          <div>
            <FormattedMessage tagName="h2" id="booking.person.replacementCard.help.header" defaultMessage="Have your lost your key card?" />
            <FormattedMessage tagName="p" id="booking.person.replacementCard.help.ln1" defaultMessage="Choose to get a new replacement card connected to your profile." />
            <FormattedMessage tagName="p" id="booking.person.replacementCard.help.ln2" defaultMessage="You pick up your key card by scanning the QR code (you can find it under ‘My bookings’) at your next booked ski time." />
            <FormattedMessage tagName="p" id="booking.person.replacementCard.help.ln3" defaultMessage="The Pick-up box is located in the skicenter at the foot of CopenHill." />
          </div>
        </Modal>
      )
    })
  }

  addInvite(email, note) {
    if (!email) {
      return
    }
    const { props, state } = this
    const { personIndex, booking } = state
    const { people } = booking

    people[personIndex].invite = {email, note}
    people[personIndex].expanded = false
    booking.people = people
    props.createBooking(booking)
    // populate errors
    props.populateErrorsOnSubmitToState()

  }

  clearBookingAttr(bookingAttr) { // TODO: Make smaller
    const { props, state } = this
    const { personIndex, booking } = state
    const { people } = booking
    people[personIndex][bookingAttr] = null
    booking.people = people
    props.createBooking(booking)
  }

  showInvitation(personIndex) {
    const { props, state} = this
    const { booking } = state

    this.clearBookingAttr('passType')
    booking.people[personIndex].invite = {}
    props.createBooking(booking)
  }

 
  render() {
    const { state, props } = this
    const { booking, personIndex, currentModal, checkingVoucher } = state
    const { people } = booking
    const person = people && people[personIndex] ? people[personIndex] : {}
    const hasRental = (
      person.rental
      && person.rental.equipment
      && !objEmpty(person.rental.equipment)
      && Object.keys(person.rental.equipment).filter(key => person.rental.equipment[key]).length > 0
    )
    const hasInstruction = (
      person
      && person.instruction
      && person.instruction.skuId
    )

    // Strange fix - throws an error in console without this
    // https://github.com/wikiwi/react-css-transition/issues/5
    CSSTransition.childContextTypes = {}

    // Check validation errors
    const { personErrors } = props
    const hasErrors = personErrors ? Object.values(personErrors).filter(item => item).length > 0 : false

    return (
      <>
        {currentModal && (
          currentModal
        )}
        <div className="border-b py-6">
          <PersonRow
            personIndex={personIndex}
            person={person}
            hasRental={hasRental}
            hasInstruction={hasInstruction}
            toggle={this.toggle}
            onChange={this.onChange}
            personValid={props.personValid}
            bookerIsLoggedIn={props.bookerIsLoggedIn}
            bookerNotAttending={booking.bookerNotAttending}
            skus={props.skus}
            personErrors={props.personErrors}
          />

          {((person.expanded && props.skus.length > 0) || hasErrors) && (
            <CSSTransition {...TransitionStyles} transitionAppear active={person.expanded || hasErrors}>
              <PersonExpandedBlock
                personIndex={personIndex}
                checkingVoucher={checkingVoucher}
                clearBookingAttr={this.clearBookingAttr}
                showInvitation={this.showInvitation}
                onChange={this.onChange}
                addInvite={this.addInvite}
                onChangeByName={this.onChangeByName}
                booking={booking}
                person={person}
                skus={props.skus}
                openPriceModal={props.openPriceModal}
                hasInstruction={hasInstruction}
                hasRental={hasRental}
                openInsuranceCancellationModal={this.openInsuranceCancellationModal}
                openInstructionModal={this.openInstructionModal}
                openRentalModal={this.openRentalModal}
                openReplacementCardModal={this.openReplacementCardModal}
                personErrors={props.personErrors}
              />
            </CSSTransition>
          )}
        </div>
      </>

    )
  }
}

BookingPersonDetailsBlock.propTypes = {
  booking: PropTypes.shape({ 
    booking: PropTypes.object
  }).isRequired,
  personIndex: PropTypes.number.isRequired,
  intl: intlShape.isRequired,
  skus: PropTypes.instanceOf(Array).isRequired,
  openPriceModal: PropTypes.func.isRequired
}

BookingPersonDetailsBlock.defaultProps = {}

const mapStateToProps = state => ({
  booking: state.booking
})

export default connect(mapStateToProps, { createBooking })(injectIntl(BookingPersonDetailsBlock))
